import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'opac-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss']
})
export class OptionComponent<T extends any> {
  private nativeElement?: HTMLElement;
  private text = '';

  multiple = false;
  visible = true;

  /**
   * Reads option container to get the text
   */
  @ViewChild('optionContainer') set optionContainer(value: ElementRef<HTMLDivElement>) {
    this.text = value.nativeElement.innerText;
    this.nativeElement = value.nativeElement;
  }

  /**
   * Internal value of option. This is the real value
   */
  @Input() value!: T;
  /**
   * Id of the option element to determine aria attributes
   */
  @Input() id: string = '';
  /**
   * Determines if option is selected
   */
  @Input() selected: boolean = false;
  /**
   * Determines if option is keyboard focused
   */
  @Input() focused: boolean = false;
  /**
   * Emits when option is selected by clicking on it
   */
  @Output() select = new EventEmitter<boolean>();

  /**
   * Returns text to work as display value
   */
  getText(): string {
    return this.text ?? '';
  }

  /**
   * Makes parent container to scroll into this option
   */
  scrollIntoView(alignment: boolean | ScrollIntoViewOptions): void {
    this.nativeElement?.scrollIntoView(alignment);
  }
}
